export default function TitleStars({className}) {
  return (
    <svg
      width="82"
      height="77"
      viewBox="0 0 82 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_d_2718_11989)">
        <path
          d="M33.2515 19.6567C32.7828 18.2639 31.4632 17.3231 29.9758 17.3211C28.4884 17.3192 27.1668 18.2565 26.6949 19.6481L21.6086 34.6455L6.39581 39.6269C4.98421 40.0891 4.03093 41.391 4.02924 42.8584C4.02756 44.3259 4.97785 45.6303 6.38839 46.0961L21.5897 51.1175L26.6415 66.1281C27.1103 67.5211 28.4297 68.4618 29.9171 68.4638C31.4045 68.4657 32.7263 67.5285 33.1982 66.1367L38.2845 51.1394L53.4971 46.158C54.9089 45.6958 55.8621 44.3939 55.8637 42.9264C55.8654 41.459 54.9152 40.1546 53.5045 39.6887L38.3034 34.6674L33.2515 19.6567Z"
          fill="#FACA20"
        />
      </g>
      <g filter="url(#filter1_d_2718_11989)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M61.8283 0.0211926C62.847 0.0225278 63.7502 0.666787 64.0714 1.62058L67.1376 10.7318L76.3645 13.7796C77.3304 14.0987 77.9813 14.9917 77.9801 15.9967C77.979 17.0016 77.326 17.893 76.3594 18.2095L67.1255 21.2331L64.0384 30.3361C63.7151 31.2891 62.8105 31.9311 61.7917 31.9298C60.773 31.9284 59.8698 31.284 59.5487 30.3302L56.4825 21.2192L47.2556 18.1714C46.2897 17.8523 45.6388 16.9592 45.6399 15.9543C45.6411 14.9493 46.294 14.058 47.2606 13.7414L56.4945 10.7178L59.5816 1.61469C59.9049 0.661747 60.8096 0.0198575 61.8283 0.0211926Z"
          fill="#FACA20"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2718_11989"
          x="0.0292969"
          y="17.3213"
          width="59.8345"
          height="59.1426"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2718_11989"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2718_11989"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2718_11989"
          x="41.6401"
          y="0.0214844"
          width="40.3398"
          height="39.9082"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2718_11989"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2718_11989"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
